<div class="dialog-container">
  <h2 mat-dialog-title>Capacitación - {{ data.title }}</h2>

  <mat-dialog-content>
    <p>Seleccione una opción:</p>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button mat-button (click)="close()">Cancelar</button>
    <button mat-button (click)="select('drive')">Abrir Presentación</button>
    <button mat-raised-button color="primary" (click)="select('play')">
      Reproducir Video
    </button>
  </mat-dialog-actions>
</div>
